import script from "./WksOpenInputPopUpBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./WksOpenInputPopUpBtn.vue?vue&type=script&setup=true&lang=ts"

import "./WksOpenInputPopUpBtn.vue?vue&type=style&index=0&id=0cdd3301&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cdd3301"]])

export default __exports__